<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import Info from "./info.vue";
import Repair from "./repair.vue";
import Track from "./track.vue";
import Change from "./change.vue";
import ImportTemplate from "@/views/components/common/form/workImportTemplate.vue";
import config from "@/../config";

export default {
  extends: baseList,
  components: {
    info: Info,
    Repair,
    Track,
    Change,
  },
  data() {
    return {
      table: {
        mname: "work",
        key: "id",
        makeMain: "",
        url: {
          list: "/customer/customer/workOrder/selectList",
        },
        output: false,
        order: "repairTime",
        // synergy: "synergyState == 0? 是:否 ",
      },
      menus: [
        {
          label: "待处理",
          name: "workOrder_await_cus",
          auth: "system/workOrder/index",
          badge: {
            mname: "workstate",
            scene: "1",
            url: "/customer/customer/workOrder/state",
          },
        },
        {
          label: "处理中",
          name: "workOrder_processing_cus",
          auth: "system/processing/index",
          badge: {
            mname: "workstate",
            scene: "2",
            url: "/customer/customer/workOrder/state",
          },
        },
        {
          label: "已完成",
          name: "workOrder_completed_cus",
          auth: "system/completed/index",
        },
      ],
      query: {
        state: 1,
      },
      actions: [],
      filters: [
        {
          label: "报修时间",
          KeyEnter: this.search,
          name: "",
          value: "",
          type: "datetimerange",
        },
        {
          label: "工单类型",
          name: "typeName",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
        {
          label: "资产名称",
          name: "facilityName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "问题描述",
          KeyEnter: this.search,
          name: "descr",
          value: "",
          type: "input",
        },
        {
          label: "科室",
          name: "department",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "资产编号",
          KeyEnter: this.search,
          name: "facilityNo",
          value: "",
          type: "input",
        },
        {
          label: "报修方式",
          name: "repairType",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "电话报修",
            },
            {
              value: 2,
              name: "扫码报修",
            },
            {
              value: 3,
              name: "移动报修",
            },
            {
              value: 4,
              name: "后台设备报修",
            },
            {
              value: 5,
              name: "后台科室报修",
            },
            {
              value: 6,
              name: "维修员",
            },
            {
              value: 7,
              name: "用户PC普通",
            },
            {
              value: 8,
              name: "用户PC快速",
            },
          ],
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "问题描述",
          key: "descr",
          width: 600,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.descr;
            let tempDescr;
            let teColor;
            if (text != null) {
              let arr = text.split("]");
              let tempDate = parseInt(arr[0]);
              if (tempDate < 5) {
                tempDescr = "[" + "0h" + tempDate + "m]" + arr[1];
                teColor = "green";
              } else if ((tempDate > 5 && tempDate < 60) || tempDate == 5) {
                teColor = "red";
                tempDescr = "[" + "0h" + tempDate + "m]" + arr[1];
              } else if (tempDate > 60 || tempDate == 60) {
                teColor = "red";
                let hour = Math.floor(tempDate / 60);
                let min = tempDate % 60;
                tempDescr = "[" + hour + "h" + min + "m]" + arr[1];
              }
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    color: teColor,
                  },
                  domProps: {
                    title: tempDescr,
                  },
                },
                tempDescr
              ),
            ]);
          },
        },
        {
          title: "报修时间",
          minWidth: 150,
          align: "center",
          key: "repairTime",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        // {
        //   title: "所在科室",
        //   key: "department",
        //   minWidth: 100,
        //   align: "center",
        //   tooltip: "true",
        // },
        // {
        //   title: "具体位置",
        //   key: "address",
        //   minWidth: 120,
        //   align: "center",
        //   tooltip: "true",
        // },

        {
          title: "工单类型",
          key: "typeName",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        // {
        //   title: "协同工单",
        //   key: "isSynergy",
        //   minWidth: 100,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.isSynergy === 0 ? "否" : "是";
        //     return <span style={{ "font-size": "14px" }}>{text}</span>;
        //   },
        // },

        {
          title: "状态",
          key: "state",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.state === 1 ? "待处理" : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        // {
        //   title: "报修来源",
        //   key: "repairSource",
        //   minWidth: 110,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text =
        //       row.repairSource === 1 && row.isFastOrder === 0
        //         ? "扫码报修"
        //         : row.repairSource === 1 && row.isFastOrder === 1
        //         ? "移动报修"
        //         : row.repairSource === 3 &&
        //           row.callId !== null &&
        //           row.isFastOrder === 1
        //         ? "电话报修"
        //         : row.repairSource === 3 && row.isFastOrder === 0
        //         ? "后台设备报修"
        //         : row.repairSource === 3 && row.isFastOrder === 1
        //         ? "后台科室报修"
        //         : row.repairSource === 2
        //         ? "维修员"
        //         : "";
        //     return <span style={{ "font-size": "14px" }}>{text}</span>;
        //   },
        // },
        {
          title: "操作",
          align: "center",
          width: 150,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [{ name: "auth", value: "system/workOrder/info" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  详情
                </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
    this.loadLevelDatas();
    this.loaddeskData();
  },
  methods: {
    deskChange(query) {
      if (query !== "") {
        setTimeout(async () => {
          let q = {
            deskName: query,
          };

          $utils.api.load(`/customer/customer/desk/list`, q, "get").then((res) => {
            const list = res.rows.map((item) => {
              return {
                value: item.id,
                name: item.deskName,
              };
            });
            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "deskId") {
                this.filters[index]["dropList"] = list;
              }
            }
          });
        }, 200);
      } else {
        this.dropList = [];
      }
    },
    loaddeskData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load(`/customer/customer/desk/list`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "deskId") {
              this.filters[index]["dropList"] = dropList;
            }
          }
        }
      });
    },
    loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/customer/customer/workType/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.name;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeName") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/customer/customer/facility/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.facilityNum;
            xx.name = element.facilityName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "facilityNo") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    toflashAdd() {
      $utils.url.push({
        name: "workOrder_add_cus",
        query: { action: "add", kv: "flash", msgkv: "flashadd" },
      });
    },
    toAdd() {
      $utils.url.push({
        name: "workOrder_add_cus",
        query: { action: "add", msgkv: "add" },
      });
    },

    //详情
    toInfo(row) {
      $utils.url.push({
        name: "workOrder_info_cus",
        query: { action: "edit", kv: row.id, workId: row.id },
      });
    },
  },
};
</script>
<style scoped></style>
